<template>
  <InfoHeader>
    <img src="~@/assets/img/rhino.png" :class="$style.image" /> Mood
  </InfoHeader>
</template>

<script>
import InfoHeader from '@/components/InfoHeader'

export default {
  name: 'mood-info-header',
  components: {
    InfoHeader
  }
}
</script>

<style module lang="scss">
.image {
  width: 50px;
  margin-right: 14px;
}
</style>
